// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company_container {
  background-color: #f6fbf6;
  border-radius: 8px;
  padding: 15px 20px;
  font-family: Arial, sans-serif;
  height: auto;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  position: relative;
  /* padding-right: 25px; */
}
.company_title {
  display: flex;
}
.title {
  font-size: 24px;
  font-weight: bold;
}
.group-search-main {
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: end;
  gap: 10px;
  margin-bottom: 5px;
  padding-right: 60px;
}
.group-search {
  width: 16%;
  border: 1px solid rgb(222, 219, 219);
}
.group-select {
  border: 1px solid rgb(219, 219, 219);
  border-radius: 6px;
}
.search-user-main {
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: start;
  gap: 7px;
}
.status-header {
  padding-top: 7px;
  padding-left: 12px;
}
.status-filter {
  display: flex;
  padding-left: 10px;
  gap: 10px;
}
.user-search {
  width: 18%;
  border: 1px solid rgb(222, 219, 219);
  height: 80%;
}

.select-users {
  border: 1px solid rgb(219, 219, 219);
  border-radius: 6px;
  height: 80%;
  font-size: 12px;
}
.table-container {
  border-radius: 8px;

  border: 1px solid #d9e3d9;
  background-color: white;
  height: 380px;
  overflow: scroll;
}
.data-rows::-webkit-scrollbar {
  width: 2px;
  border-radius: 2px;
}

.header-rows,
.data-rows {
  display: grid;
  grid-template-columns: 1fr 2fr 2fr 3fr 1.5fr 2.5fr 2fr 1fr;
  padding: 10px;
  height: 36px;
  font-size: 12px;
  text-align: left;
  justify-items: left;
}

.header-rows {
  background-color: #d8f3d8;
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 1;
}

.data-row-department {
  text-align: left;
  /* padding-left: 24px; */
}
.data-row-designation{
  overflow:hidden;
}
.data-row-designation ::-webkit-scrollbar{
  display: none;
}
.data-rows {
  border-top: 1px solid #d9e3d9;
}

.data-row:nth-child(odd) {
  background-color: #f9f9f9;
}

.action-icons {
  display: flex;
  gap: 50px;
}

.action-icon {
  height: 18px;
  width: 15px;
}

button {
  cursor: pointer;
  border: none;
  outline: none;
  background: transparent;
}

.create-button {
  padding: 5px 8px;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: rgb(116, 197, 167);
  gap: 12px;
  height: 33px;
  width: 84px;
}

.create-button:hover {
  background-color: rgb(116, 197, 167);
}

.dropdown-arrow {
  font-size: 13px;
  transition: transform 0.3s;
}

.dropdown_create {
  position: relative;

  .dropdown-options_create {
    position: absolute;
    top: 100%;
    /* left: -33px; */
    background-color: white;
    border-radius: 4px;
    width: 111px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 10;
  }

  .dropdown-option {
    padding: 12px 6px;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #6fa27c;
    font-size: 14px;
  }

  .dropdown-option:hover {
    background-color: #d8f3d8;
  }
}

.dropdown-option svg {
  margin-right: 8px;
}

.dropdown.open .dropdown-arrow {
  transform: rotate(180deg);
}

.dropdown-item-user {
  display: flex;
  flex-direction: row;
  gap: 25px;
}
.bulk_heading {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
  color: #154139;
}
.popup {
  width: 30%;
}

.SampleDownBtn {
  font-size: 16px;
}
.bulkDownBtn {
  padding: 10px 20px;
  border-radius: 8px;
  background-color: #96d8a7a1;
  height: 45px;
  font-size: 16px;
  margin-left: 20px;
}
.enterCompanyCode {
  margin-top: 30px;
  padding-left: 12px;
}
.companyCodeSelect {
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #96d8a7;
  appearance: none;
  font-size: 16px;
}
.file-upload-bulk {
  margin-top: 20px;
}
.uploadBulkBtn {
  padding: 5px 10px;
  border-radius: 8px;
  background-color: #96d8a7;
  height: 35px;
  font-size: 16px;
  color: black;
}
.closeBtnBulk {
  font-size: 45px;
  color: beige;
  margin-left: 20px;
  top: -4em;
  left: -15px;
  position: relative;
}

.submitBtnmutli {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.user_pagination {
  margin-top: 1px;
  display: flex;
  gap: 10px;
  justify-content: center;
  & .previous-button {
    padding: 2px;
    border-radius: 5px;
    box-shadow: 2px 2px 5px #4caf509c;
  }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .table-container {
    overflow-x: auto;
    border: 1px solid #ccc;
    border-radius: 8px;
    background-color: #fff;
    height: 400px;
  }

  .header-rows,
  .data-rows {
    display: grid;
    grid-template-columns: 0.8fr 1.2fr 2fr 3fr 2fr 2fr 2fr 1.5fr; /* 8 columns */
    align-items: center;
    justify-items: center;
    padding: 10px;
    min-width: 1000px;
    text-align: center;
    gap: 10px;
  }

  .header-rows {
    background-color: #f0f0f0;
    font-weight: bold;
    border-bottom: 1px solid #ccc;
  }

  .data-rows {
    border-bottom: 1px solid #eee;
    font-size: 14px;
  }

  .action-icons {
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
  }

  .action-icon {
    font-size: 18px;
    color: #84c7ae;
    cursor: pointer;
  }
}

@media screen and (min-width: 1440px) {
  .table-container {
    overflow-x: auto; /* Keep for safety, though less likely needed */

    height: 500px; /* Increased height for larger screens */
  }

  .header-rows,
  .data-rows {
    /* Corrected .data-rows to .data-row */
    display: grid;
    grid-template-columns: 0.8fr 1.2fr 2fr 3fr 2fr 2fr 2fr 1.5fr; /* Using the same grid as 768-1024px */
    align-items: center;
    justify-items: center;
    padding: 10px;
    /* min-width: 1000px; Removed min-width */
    text-align: center;
    gap: 10px;
  }

  .header-rows {
    background-color: #f0f0f0;
    font-weight: bold;
    border-bottom: 1px solid #ccc;
  }
}

/* .user_pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end; 
  padding: 16px;
  gap: 10px;
} */

.pagination-arrow {
  background-color: rgb(116, 197, 167);
  color: white;
  border: 1px solid #ccc;
  /* padding: 6px 10px; */
  cursor: pointer;
  border-radius: 4px;
}

.pagination-info {
  font-size: 12px;
  color: #333;
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/Users/CompanyAllUsers.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,UAAU;EACV,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;;EAElB,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,0DAA0D;EAC1D,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,SAAS;EACT,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;;EAElB;IACE,kBAAkB;IAClB,SAAS;IACT,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,yCAAyC;IACzC,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB;IACE,YAAY;IACZ,kBAAkB;IAClB,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;EACf;;EAEA;;IAEE,aAAa;IACb,4DAA4D,EAAE,cAAc;IAC5E,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;IAC7B,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB,EAAE,+CAA+C;;IAEjE,aAAa,EAAE,wCAAwC;EACzD;;EAEA;;IAEE,sCAAsC;IACtC,aAAa;IACb,4DAA4D,EAAE,sCAAsC;IACpG,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;IACb,yCAAyC;IACzC,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,6BAA6B;EAC/B;AACF;;AAEA;;;;;;GAMG;;AAEH;EACE,oCAAoC;EACpC,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb","sourcesContent":[".company_container {\n  background-color: #f6fbf6;\n  border-radius: 8px;\n  padding: 15px 20px;\n  font-family: Arial, sans-serif;\n  height: auto;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px;\n  position: relative;\n  /* padding-right: 25px; */\n}\n.company_title {\n  display: flex;\n}\n.title {\n  font-size: 24px;\n  font-weight: bold;\n}\n.group-search-main {\n  width: 100%;\n  height: 30px;\n  display: flex;\n  justify-content: end;\n  gap: 10px;\n  margin-bottom: 5px;\n  padding-right: 60px;\n}\n.group-search {\n  width: 16%;\n  border: 1px solid rgb(222, 219, 219);\n}\n.group-select {\n  border: 1px solid rgb(219, 219, 219);\n  border-radius: 6px;\n}\n.search-user-main {\n  width: 100%;\n  height: 30px;\n  display: flex;\n  justify-content: start;\n  gap: 7px;\n}\n.status-header {\n  padding-top: 7px;\n  padding-left: 12px;\n}\n.status-filter {\n  display: flex;\n  padding-left: 10px;\n  gap: 10px;\n}\n.user-search {\n  width: 18%;\n  border: 1px solid rgb(222, 219, 219);\n  height: 80%;\n}\n\n.select-users {\n  border: 1px solid rgb(219, 219, 219);\n  border-radius: 6px;\n  height: 80%;\n  font-size: 12px;\n}\n.table-container {\n  border-radius: 8px;\n\n  border: 1px solid #d9e3d9;\n  background-color: white;\n  height: 380px;\n  overflow: scroll;\n}\n.data-rows::-webkit-scrollbar {\n  width: 2px;\n  border-radius: 2px;\n}\n\n.header-rows,\n.data-rows {\n  display: grid;\n  grid-template-columns: 1fr 2fr 2fr 3fr 1.5fr 2.5fr 2fr 1fr;\n  padding: 10px;\n  height: 36px;\n  font-size: 12px;\n  text-align: left;\n  justify-items: left;\n}\n\n.header-rows {\n  background-color: #d8f3d8;\n  font-weight: bold;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.data-row-department {\n  text-align: left;\n  /* padding-left: 24px; */\n}\n.data-row-designation{\n  overflow:hidden;\n}\n.data-row-designation ::-webkit-scrollbar{\n  display: none;\n}\n.data-rows {\n  border-top: 1px solid #d9e3d9;\n}\n\n.data-row:nth-child(odd) {\n  background-color: #f9f9f9;\n}\n\n.action-icons {\n  display: flex;\n  gap: 50px;\n}\n\n.action-icon {\n  height: 18px;\n  width: 15px;\n}\n\nbutton {\n  cursor: pointer;\n  border: none;\n  outline: none;\n  background: transparent;\n}\n\n.create-button {\n  padding: 5px 8px;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  background-color: rgb(116, 197, 167);\n  gap: 12px;\n  height: 33px;\n  width: 84px;\n}\n\n.create-button:hover {\n  background-color: rgb(116, 197, 167);\n}\n\n.dropdown-arrow {\n  font-size: 13px;\n  transition: transform 0.3s;\n}\n\n.dropdown_create {\n  position: relative;\n\n  .dropdown-options_create {\n    position: absolute;\n    top: 100%;\n    /* left: -33px; */\n    background-color: white;\n    border-radius: 4px;\n    width: 111px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    z-index: 10;\n  }\n\n  .dropdown-option {\n    padding: 12px 6px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    color: #6fa27c;\n    font-size: 14px;\n  }\n\n  .dropdown-option:hover {\n    background-color: #d8f3d8;\n  }\n}\n\n.dropdown-option svg {\n  margin-right: 8px;\n}\n\n.dropdown.open .dropdown-arrow {\n  transform: rotate(180deg);\n}\n\n.dropdown-item-user {\n  display: flex;\n  flex-direction: row;\n  gap: 25px;\n}\n.bulk_heading {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 30px;\n  color: #154139;\n}\n.popup {\n  width: 30%;\n}\n\n.SampleDownBtn {\n  font-size: 16px;\n}\n.bulkDownBtn {\n  padding: 10px 20px;\n  border-radius: 8px;\n  background-color: #96d8a7a1;\n  height: 45px;\n  font-size: 16px;\n  margin-left: 20px;\n}\n.enterCompanyCode {\n  margin-top: 30px;\n  padding-left: 12px;\n}\n.companyCodeSelect {\n  width: 100%;\n  padding: 10px;\n  border-radius: 8px;\n  border: 1px solid #96d8a7;\n  appearance: none;\n  font-size: 16px;\n}\n.file-upload-bulk {\n  margin-top: 20px;\n}\n.uploadBulkBtn {\n  padding: 5px 10px;\n  border-radius: 8px;\n  background-color: #96d8a7;\n  height: 35px;\n  font-size: 16px;\n  color: black;\n}\n.closeBtnBulk {\n  font-size: 45px;\n  color: beige;\n  margin-left: 20px;\n  top: -4em;\n  left: -15px;\n  position: relative;\n}\n\n.submitBtnmutli {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n}\n\n.user_pagination {\n  margin-top: 1px;\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  & .previous-button {\n    padding: 2px;\n    border-radius: 5px;\n    box-shadow: 2px 2px 5px #4caf509c;\n  }\n}\n\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .table-container {\n    overflow-x: auto;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    background-color: #fff;\n    height: 400px;\n  }\n\n  .header-rows,\n  .data-rows {\n    display: grid;\n    grid-template-columns: 0.8fr 1.2fr 2fr 3fr 2fr 2fr 2fr 1.5fr; /* 8 columns */\n    align-items: center;\n    justify-items: center;\n    padding: 10px;\n    min-width: 1000px;\n    text-align: center;\n    gap: 10px;\n  }\n\n  .header-rows {\n    background-color: #f0f0f0;\n    font-weight: bold;\n    border-bottom: 1px solid #ccc;\n  }\n\n  .data-rows {\n    border-bottom: 1px solid #eee;\n    font-size: 14px;\n  }\n\n  .action-icons {\n    display: flex;\n    gap: 10px;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .action-icon {\n    font-size: 18px;\n    color: #84c7ae;\n    cursor: pointer;\n  }\n}\n\n@media screen and (min-width: 1440px) {\n  .table-container {\n    overflow-x: auto; /* Keep for safety, though less likely needed */\n\n    height: 500px; /* Increased height for larger screens */\n  }\n\n  .header-rows,\n  .data-rows {\n    /* Corrected .data-rows to .data-row */\n    display: grid;\n    grid-template-columns: 0.8fr 1.2fr 2fr 3fr 2fr 2fr 2fr 1.5fr; /* Using the same grid as 768-1024px */\n    align-items: center;\n    justify-items: center;\n    padding: 10px;\n    /* min-width: 1000px; Removed min-width */\n    text-align: center;\n    gap: 10px;\n  }\n\n  .header-rows {\n    background-color: #f0f0f0;\n    font-weight: bold;\n    border-bottom: 1px solid #ccc;\n  }\n}\n\n/* .user_pagination {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end; \n  padding: 16px;\n  gap: 10px;\n} */\n\n.pagination-arrow {\n  background-color: rgb(116, 197, 167);\n  color: white;\n  border: 1px solid #ccc;\n  /* padding: 6px 10px; */\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.pagination-info {\n  font-size: 12px;\n  color: #333;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
